// extracted by mini-css-extract-plugin
export default {"selected":"ScanAndInit_selected__S+i8x","no-bg":"ScanAndInit_no-bg__8Zu-z"};